var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row between pb-15 v-c"},[_c('h4',{staticClass:"p-0 m-0 mt-20 strong"},[_vm._v(_vm._s(_vm.title))]),_c('span',[_c('button',{staticClass:"gray",style:({
          padding: '2px 16px',
          marginTop: '20px'
      }),on:{"click":function () { return this$1.collapsed = !this$1.collapsed; }}},[_vm._v(" "+_vm._s(_vm.collapsed ? "+" : "-")+" ")])])]),(!_vm.collapsed)?_vm._t("default"):_c('hr')],2)}
var staticRenderFns = []

export { render, staticRenderFns }